import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createBlock as _createBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "popup__content" }
const _hoisted_2 = {
  key: 0,
  class: "deal-tab"
}
const _hoisted_3 = { class: "deal-tab__row" }
const _hoisted_4 = { class: "deal-tab__label text-capitalize-first" }
const _hoisted_5 = { class: "deal-tab__info" }
const _hoisted_6 = { class: "d-flex align-items-center gap-xs" }
const _hoisted_7 = {
  key: 0,
  class: "deal-tab__row"
}
const _hoisted_8 = { class: "deal-tab__label text-capitalize-first" }
const _hoisted_9 = { class: "deal-tab__info" }
const _hoisted_10 = { class: "d-flex align-items-center gap-xs" }
const _hoisted_11 = { class: "deal-tab__row" }
const _hoisted_12 = { class: "deal-tab__label text-capitalize-first" }
const _hoisted_13 = { class: "deal-tab__info" }
const _hoisted_14 = { class: "deal-tab__row" }
const _hoisted_15 = { class: "deal-tab__label text-capitalize-first" }
const _hoisted_16 = { class: "deal-tab__info" }
const _hoisted_17 = { class: "deal-tab__row" }
const _hoisted_18 = { class: "deal-tab__label text-capitalize-first" }
const _hoisted_19 = { class: "deal-tab__info" }
const _hoisted_20 = ["href"]
const _hoisted_21 = { class: "deal-tab__row" }
const _hoisted_22 = { class: "deal-tab__label text-capitalize-first" }
const _hoisted_23 = { class: "deal-tab__info" }
const _hoisted_24 = { key: 0 }
const _hoisted_25 = { key: 1 }
const _hoisted_26 = { class: "deal-tab__row" }
const _hoisted_27 = { class: "deal-tab__label text-capitalize-first" }
const _hoisted_28 = { class: "deal-tab__info" }
const _hoisted_29 = { key: 0 }
const _hoisted_30 = {
  key: 2,
  class: "ms-1"
}
const _hoisted_31 = {
  key: 3,
  class: "ms-1 small text-secondary"
}
const _hoisted_32 = { key: 0 }
const _hoisted_33 = { class: "deal-tab__row" }
const _hoisted_34 = { class: "deal-tab__label text-capitalize-first" }
const _hoisted_35 = { class: "deal-tab__info" }
const _hoisted_36 = { key: 0 }
const _hoisted_37 = {
  key: 2,
  class: "ms-1"
}
const _hoisted_38 = {
  key: 3,
  class: "ms-1 small text-secondary"
}
const _hoisted_39 = { key: 0 }
const _hoisted_40 = { class: "deal-tab__row" }
const _hoisted_41 = { class: "deal-tab__label text-capitalize-first" }
const _hoisted_42 = { class: "deal-tab__info" }
const _hoisted_43 = { key: 0 }
const _hoisted_44 = { class: "deal-tab__row" }
const _hoisted_45 = { class: "deal-tab__label text-capitalize-first" }
const _hoisted_46 = { class: "deal-tab__info" }
const _hoisted_47 = { class: "deal-tab__label text-capitalize-first" }
const _hoisted_48 = { class: "deal-tab__info" }
const _hoisted_49 = { class: "download-documents__card-info card-info" }
const _hoisted_50 = { class: "card-info__title" }
const _hoisted_51 = { class: "card-info__number" }
const _hoisted_52 = {
  key: 3,
  class: "text-secondary"
}
const _hoisted_53 = ["href"]
const _hoisted_54 = ["href"]
const _hoisted_55 = ["href"]
const _hoisted_56 = ["href"]
const _hoisted_57 = { key: 4 }
const _hoisted_58 = { key: 5 }
const _hoisted_59 = { class: "card-info__name" }
const _hoisted_60 = { key: 0 }
const _hoisted_61 = { key: 1 }
const _hoisted_62 = {
  key: 1,
  class: "deal-tab__row"
}
const _hoisted_63 = { class: "deal-tab__label text-capitalize-first" }
const _hoisted_64 = { class: "deal-tab__info" }
const _hoisted_65 = {
  key: 2,
  class: "deal-tab__row deal-tab__row--last"
}
const _hoisted_66 = { class: "deal-tab__label text-capitalize-first" }
const _hoisted_67 = { class: "deal-tab__info" }
const _hoisted_68 = {
  key: 3,
  class: "deal-tab__row deal-tab__row--last"
}
const _hoisted_69 = { class: "deal-tab__label text-capitalize-first" }
const _hoisted_70 = { class: "deal-tab__info" }
const _hoisted_71 = {
  key: 4,
  class: "deal-tab__row deal-tab__row--last"
}
const _hoisted_72 = { class: "deal-tab__label text-capitalize-first" }
const _hoisted_73 = { class: "deal-tab__info" }
const _hoisted_74 = ["disabled", "title"]
const _hoisted_75 = { key: 0 }
const _hoisted_76 = { class: "popup__title mb mt" }
const _hoisted_77 = { class: "text-capitalize-first" }
const _hoisted_78 = { class: "popup__content" }
const _hoisted_79 = { class: "deal-tab" }
const _hoisted_80 = { class: "deal-tab__row" }
const _hoisted_81 = { class: "deal-tab__label text-capitalize-first" }
const _hoisted_82 = { class: "deal-tab__info" }
const _hoisted_83 = { class: "d-flex align-items-center gap-xs" }
const _hoisted_84 = {
  key: 0,
  class: "deal-tab__row"
}
const _hoisted_85 = { class: "deal-tab__label text-capitalize-first" }
const _hoisted_86 = { class: "deal-tab__info" }
const _hoisted_87 = { class: "d-flex align-items-center gap-xs" }
const _hoisted_88 = {
  key: 1,
  class: "deal-tab__row"
}
const _hoisted_89 = { class: "deal-tab__label text-capitalize-first" }
const _hoisted_90 = { class: "deal-tab__info" }
const _hoisted_91 = { class: "d-flex align-items-center gap-xs" }
const _hoisted_92 = {
  key: 2,
  class: "deal-tab__row"
}
const _hoisted_93 = { class: "deal-tab__label text-capitalize-first" }
const _hoisted_94 = { class: "deal-tab__info" }
const _hoisted_95 = { class: "d-flex align-items-center gap-xs" }
const _hoisted_96 = { class: "deal-tab__row" }
const _hoisted_97 = { class: "deal-tab__label text-capitalize-first" }
const _hoisted_98 = { class: "deal-tab__info" }
const _hoisted_99 = { class: "d-flex align-items-center gap-xs" }
const _hoisted_100 = { class: "deal-tab__row" }
const _hoisted_101 = { class: "deal-tab__label text-capitalize-first" }
const _hoisted_102 = { class: "deal-tab__info" }
const _hoisted_103 = { class: "d-flex align-items-center gap-xs" }
const _hoisted_104 = { class: "deal-tab__row" }
const _hoisted_105 = { class: "deal-tab__label text-capitalize-first" }
const _hoisted_106 = { class: "deal-tab__info" }
const _hoisted_107 = { class: "d-flex align-items-center gap-xs" }
const _hoisted_108 = { class: "popup__title mb mt" }
const _hoisted_109 = { class: "text-capitalize-first" }
const _hoisted_110 = { class: "popup__content" }
const _hoisted_111 = { style: {"overflow":"auto"} }
const _hoisted_112 = {
  class: "table table-striped",
  style: {"position":"relative"}
}
const _hoisted_113 = { class: "text-start p-sm" }
const _hoisted_114 = { class: "text-start p-sm" }
const _hoisted_115 = {
  class: "text-start p-sm",
  colspan: "2"
}
const _hoisted_116 = { class: "p-sm" }
const _hoisted_117 = { class: "p-sm" }
const _hoisted_118 = { class: "d-flex flex-column" }
const _hoisted_119 = { key: 0 }
const _hoisted_120 = { key: 1 }
const _hoisted_121 = ["href"]
const _hoisted_122 = {
  key: 0,
  class: "text-muted"
}
const _hoisted_123 = {
  key: 1,
  class: "text-muted"
}
const _hoisted_124 = {
  key: 2,
  class: "text-danger"
}
const _hoisted_125 = { class: "text-lowercase" }
const _hoisted_126 = {
  key: 4,
  class: "text-lowercase text-danger"
}
const _hoisted_127 = { class: "p-sm" }
const _hoisted_128 = {
  key: 0,
  class: "text-capitalize-first d-inline-block"
}
const _hoisted_129 = { key: 1 }
const _hoisted_130 = {
  key: 0,
  class: "popup__content"
}
const _hoisted_131 = { class: "form-group mb-3" }
const _hoisted_132 = { class: "form-label text-capitalize-first" }
const _hoisted_133 = ["value"]
const _hoisted_134 = { class: "form-group mb-3" }
const _hoisted_135 = { class: "form-label text-capitalize-first" }
const _hoisted_136 = ["value"]
const _hoisted_137 = { class: "form-group mb-3" }
const _hoisted_138 = { class: "form-label text-capitalize-first" }
const _hoisted_139 = ["value"]
const _hoisted_140 = { class: "form-group mb-3" }
const _hoisted_141 = { class: "form-label text-capitalize-first" }
const _hoisted_142 = ["value"]
const _hoisted_143 = { class: "d-flex justify-content-end mt-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_copy_button = _resolveComponent("copy-button")!
  const _component_SvgIcon = _resolveComponent("SvgIcon")!
  const _component_ReceiptCheckControl = _resolveComponent("ReceiptCheckControl")!
  const _component_PayMethodIcon = _resolveComponent("PayMethodIcon")!
  const _component_PayoutQrBlock = _resolveComponent("PayoutQrBlock")!
  const _component_VietQrPaymentBlock = _resolveComponent("VietQrPaymentBlock")!
  const _component_ManualSbpQrLinkEditor = _resolveComponent("ManualSbpQrLinkEditor")!
  const _component_ExternalNspkSender = _resolveComponent("ExternalNspkSender")!
  const _component_ReceiptCheckStatus = _resolveComponent("ReceiptCheckStatus")!
  const _component_b_pagination = _resolveComponent("b-pagination")!
  const _component_LoaderContent = _resolveComponent("LoaderContent")!
  const _component_Popup = _resolveComponent("Popup")!
  const _component_ConfirmPopup = _resolveComponent("ConfirmPopup")!

  return (_openBlock(), _createBlock(_component_Popup, {
    ref: (el) => _ctx.popup = el,
    class: "popup__lg",
    title: _ctx.$t('labels.trade_deal'),
    onOnClose: _ctx.hide
  }, {
    default: _withCtx(() => [
      _createVNode(_component_LoaderContent, {
        ref: "loader",
        class: ""
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            (_ctx.deal)
              ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                  _createElementVNode("div", _hoisted_3, [
                    _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$t('labels.id')), 1),
                    _createElementVNode("div", _hoisted_5, [
                      _createElementVNode("div", _hoisted_6, [
                        _createTextVNode(_toDisplayString(_ctx.deal.publicId) + " ", 1),
                        _createVNode(_component_copy_button, {
                          value: _ctx.deal?.publicId
                        }, null, 8, ["value"])
                      ])
                    ])
                  ]),
                  (_ctx.deal.transactionId)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                        _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.$t('labels.transaction')), 1),
                        _createElementVNode("div", _hoisted_9, [
                          _createElementVNode("div", _hoisted_10, [
                            _createTextVNode(_toDisplayString(_ctx.deal.transactionId) + " ", 1),
                            _createVNode(_component_copy_button, {
                              value: _ctx.deal.transactionId
                            }, null, 8, ["value"])
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.$t('labels.type')), 1),
                    _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.$t(`direction.${_ctx.deal.type}`)), 1)
                  ]),
                  _createElementVNode("div", _hoisted_14, [
                    _createElementVNode("div", _hoisted_15, _toDisplayString(_ctx.$t('labels.date')), 1),
                    _createElementVNode("div", _hoisted_16, _toDisplayString(_ctx.dateHelper.format(_ctx.deal.createdAt)), 1)
                  ]),
                  _createElementVNode("div", _hoisted_17, [
                    _createElementVNode("div", _hoisted_18, _toDisplayString(_ctx.helper.trans('labels.status')), 1),
                    _createElementVNode("div", _hoisted_19, [
                      _createTextVNode(_toDisplayString(_ctx.helper.trans(`deal_status.${_ctx.deal.status}`)) + " ", 1),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.deal.attachments, (attachment) => {
                        return (_openBlock(), _createElementBlock(_Fragment, {
                          key: attachment.id
                        }, [
                          _createElementVNode("a", {
                            href: `${_ctx.api.baseUrl()}/attachments/${attachment.file}`,
                            target: "_blank"
                          }, [
                            _createVNode(_component_SvgIcon, {
                              class: "icon icon__warning icon__small",
                              icon: "paperclip"
                            })
                          ], 8, _hoisted_20),
                          _createVNode(_component_ReceiptCheckControl, {
                            deal: _ctx.deal,
                            attachment: attachment
                          }, null, 8, ["deal", "attachment"])
                        ], 64))
                      }), 128))
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_21, [
                    _createElementVNode("div", _hoisted_22, _toDisplayString(_ctx.rateHeader), 1),
                    _createElementVNode("div", _hoisted_23, [
                      _createElementVNode("span", null, _toDisplayString(_ctx.numberFormatter.formatNumber(_ctx.deal.takerSum.amount / _ctx.deal.makerSum.amount, _ctx.deal.takerSum.subunit)) + " " + _toDisplayString(_ctx.deal.takerSum.currency), 1),
                      (_ctx.deal.merchantMakerSum)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_24, " / " + _toDisplayString(_ctx.numberFormatter.formatNumber(_ctx.deal.takerSum.amount / _ctx.deal.merchantMakerSum.amount, _ctx.deal.takerSum.subunit)) + " " + _toDisplayString(_ctx.deal.takerSum.currency), 1))
                        : _createCommentVNode("", true),
                      (_ctx.isEffectiveRateEnabled && _ctx.deal.rewardSum)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_25, " / " + _toDisplayString(_ctx.numberFormatter.formatNumber((_ctx.deal.takerSum.amount / _ctx.deal.makerSum.amount) * (1 + _ctx.deal.rewardSum.amount/_ctx.deal.makerSum.amount), _ctx.deal.takerSum.subunit)) + " " + _toDisplayString(_ctx.deal.takerSum.currency), 1))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_26, [
                    _createElementVNode("div", _hoisted_27, _toDisplayString(_ctx.helper.trans('labels.in_sum')), 1),
                    _createElementVNode("div", _hoisted_28, [
                      _createElementVNode("div", null, [
                        (_ctx.deal.actualTakerSum)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_29, _toDisplayString(_ctx.numberFormatter.formatMoney(_ctx.deal.actualTakerSum)), 1))
                          : (_openBlock(), _createElementBlock("span", {
                              key: 1,
                              class: _normalizeClass({'text-decoration-line-through': _ctx.deal.isActualSumsChanged})
                            }, _toDisplayString(_ctx.numberFormatter.formatMoney(_ctx.deal.takerSum)), 3)),
                        (_ctx.deal.takerSum.currency !== _ctx.deal.makerSum.currency)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_30, "/"))
                          : _createCommentVNode("", true),
                        (_ctx.deal.takerSum.currency !== _ctx.deal.makerSum.currency)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_31, [
                              (_ctx.deal.actualMakerSum)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_32, _toDisplayString(_ctx.numberFormatter.formatMoney(_ctx.deal.actualMakerSum)), 1))
                                : (_openBlock(), _createElementBlock("span", {
                                    key: 1,
                                    class: _normalizeClass({'text-decoration-line-through': _ctx.deal.isActualSumsChanged})
                                  }, _toDisplayString(_ctx.numberFormatter.formatMoney(_ctx.deal.makerSum)), 3))
                            ]))
                          : _createCommentVNode("", true)
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_33, [
                    _createElementVNode("div", _hoisted_34, _toDisplayString(_ctx.helper.trans('labels.out_sum')), 1),
                    _createElementVNode("div", _hoisted_35, [
                      _createElementVNode("div", null, [
                        (_ctx.deal.actualMakerSum)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_36, _toDisplayString(_ctx.deal.type === _ctx.Direction.PAY_IN ? '-' : '+') + _toDisplayString(_ctx.numberFormatter.formatMoney(_ctx.deal.actualMakerSum)), 1))
                          : (_openBlock(), _createElementBlock("span", {
                              key: 1,
                              class: _normalizeClass({'text-decoration-line-through': _ctx.deal.isActualSumsChanged})
                            }, _toDisplayString(_ctx.deal.type === _ctx.Direction.PAY_IN ? '-' : '+') + _toDisplayString(_ctx.numberFormatter.formatMoney(_ctx.deal.makerSum)), 3)),
                        (_ctx.deal.takerSum.currency !== _ctx.deal.makerSum.currency)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_37, "/"))
                          : _createCommentVNode("", true),
                        (_ctx.deal.takerSum.currency !== _ctx.deal.makerSum.currency)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_38, [
                              (_ctx.deal.actualTakerSum)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_39, _toDisplayString(_ctx.numberFormatter.formatMoney(_ctx.deal.actualTakerSum)), 1))
                                : (_openBlock(), _createElementBlock("span", {
                                    key: 1,
                                    class: _normalizeClass({'text-decoration-line-through': _ctx.deal.isActualSumsChanged})
                                  }, _toDisplayString(_ctx.numberFormatter.formatMoney(_ctx.deal.takerSum)), 3))
                            ]))
                          : _createCommentVNode("", true)
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_40, [
                    _createElementVNode("div", _hoisted_41, _toDisplayString(_ctx.helper.trans('labels.reward_sum')), 1),
                    _createElementVNode("div", _hoisted_42, [
                      (_ctx.deal.actualRewardSum)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_43, _toDisplayString(_ctx.numberFormatter.formatMoney(_ctx.deal.actualRewardSum)), 1))
                        : _createCommentVNode("", true),
                      (_ctx.deal.rewardSum && (!_ctx.deal.actualRewardSum || _ctx.deal.isActualSumsChanged))
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 1,
                            class: _normalizeClass({'text-decoration-line-through': _ctx.deal.isActualSumsChanged})
                          }, _toDisplayString(_ctx.numberFormatter.formatMoney(_ctx.deal.rewardSum)), 3))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_44, [
                    _createElementVNode("div", _hoisted_45, _toDisplayString(_ctx.helper.trans('labels.buyer')), 1),
                    _createElementVNode("div", _hoisted_46, _toDisplayString(_ctx.deal.takerId ?? 'n/a'), 1)
                  ]),
                  _createElementVNode("div", {
                    class: _normalizeClass(["deal-tab__row", {'deal-tab__row--last': _ctx.deal.paymentOption !== _ctx.PaymentOption.MANUAL_ECOM && !_ctx.showManualSbpQrAttachRow}])
                  }, [
                    _createElementVNode("div", _hoisted_47, _toDisplayString(_ctx.helper.trans('labels.requisites')), 1),
                    _createElementVNode("div", _hoisted_48, [
                      _createElementVNode("div", _hoisted_49, [
                        _createElementVNode("div", _hoisted_50, _toDisplayString(_ctx.helper.trans('payment_options.' + _ctx.deal.paymentOption)), 1),
                        _createElementVNode("div", _hoisted_51, [
                          _createVNode(_component_PayMethodIcon, {
                            method: _ctx.deal.paymentMethod
                          }, null, 8, ["method"]),
                          (_ctx.deal.type === _ctx.Direction.PAY_OUT && _ctx.deal.payoutQr?.link)
                            ? (_openBlock(), _createBlock(_component_PayoutQrBlock, {
                                key: 0,
                                link: _ctx.deal.payoutQr.link
                              }, null, 8, ["link"]))
                            : (_ctx.helper.isEmvQrOption(_ctx.deal.paymentOption))
                              ? (_openBlock(), _createBlock(_component_VietQrPaymentBlock, {
                                  key: 1,
                                  "deal-id": _ctx.deal.id,
                                  "qr-code-data": _ctx.deal.qrCodeData ?? null,
                                  "qr-code-link": _ctx.helper.emvQrData(_ctx.deal),
                                  "fallback-requisites": _ctx.deal.paymentRequisites.requisites || ''
                                }, null, 8, ["deal-id", "qr-code-data", "qr-code-link", "fallback-requisites"]))
                              : (_ctx.deal.paymentOption === _ctx.PaymentOption.MANUAL_SBP_QR && _ctx.helper.dealQrCodeLink(_ctx.deal))
                                ? (_openBlock(), _createBlock(_component_VietQrPaymentBlock, {
                                    key: 2,
                                    "deal-id": _ctx.deal.id,
                                    "qr-code-data": null,
                                    "qr-code-link": _ctx.helper.dealQrCodeLink(_ctx.deal),
                                    "fallback-requisites": ''
                                  }, null, 8, ["deal-id", "qr-code-link"]))
                                : (_ctx.deal.paymentOption === _ctx.PaymentOption.MANUAL_SBP_QR)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_52, "—"))
                                  : (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
                                      (_ctx.deal.paymentOption === _ctx.PaymentOption.SBP_QR && _ctx.deal.paymentRequisites.requisites?.startsWith('http'))
                                        ? (_openBlock(), _createElementBlock("a", {
                                            key: 0,
                                            href: _ctx.deal.paymentRequisites.requisites,
                                            target: "_blank"
                                          }, _toDisplayString(_ctx.helper.domain(_ctx.deal.paymentRequisites.requisites)), 9, _hoisted_53))
                                        : (_ctx.deal.paymentOption === _ctx.PaymentOption.CLICK_UZ_QR && _ctx.deal.paymentRequisites.requisites?.startsWith('http'))
                                          ? (_openBlock(), _createElementBlock("a", {
                                              key: 1,
                                              href: _ctx.deal.paymentRequisites.requisites,
                                              target: "_blank"
                                            }, _toDisplayString(_ctx.helper.trans('labels.my_click_uz')), 9, _hoisted_54))
                                          : (_ctx.deal.paymentOption === _ctx.PaymentOption.TIPS && _ctx.deal.paymentRequisites.requisites?.startsWith('http'))
                                            ? (_openBlock(), _createElementBlock("a", {
                                                key: 2,
                                                href: _ctx.deal.paymentRequisites.requisites,
                                                target: "_blank"
                                              }, _toDisplayString(_ctx.helper.domain(_ctx.deal.paymentRequisites.requisites)), 9, _hoisted_55))
                                            : (_ctx.deal.paymentRequisites.requisites?.startsWith('http'))
                                              ? (_openBlock(), _createElementBlock("a", {
                                                  key: 3,
                                                  href: _ctx.deal.paymentRequisites.requisites,
                                                  target: "_blank"
                                                }, _toDisplayString(_ctx.helper.domain(_ctx.deal.paymentRequisites.requisites)), 9, _hoisted_56))
                                              : (_ctx.deal.paymentOption === _ctx.PaymentOption.MANUAL_ECOM || _ctx.deal.paymentOption === _ctx.PaymentOption.TO_CARD)
                                                ? (_openBlock(), _createElementBlock("span", _hoisted_57, _toDisplayString(_ctx.formatCardRequisites(_ctx.deal.paymentRequisites.requisites)), 1))
                                                : (_openBlock(), _createElementBlock("span", _hoisted_58, _toDisplayString(_ctx.deal.paymentRequisites.requisites), 1))
                                    ], 64))
                        ]),
                        _createElementVNode("div", _hoisted_59, [
                          (_ctx.deal.paymentOption === _ctx.PaymentOption.SBP_QR && _ctx.deal.requisites && !_ctx.deal.requisites.requisites.startsWith('http'))
                            ? (_openBlock(), _createElementBlock("div", _hoisted_60, _toDisplayString(_ctx.deal.requisites.requisites), 1))
                            : (_openBlock(), _createElementBlock("div", _hoisted_61, _toDisplayString(_ctx.deal.paymentRequisites.holder), 1))
                        ])
                      ])
                    ])
                  ], 2),
                  (_ctx.deal.paymentOption === _ctx.PaymentOption.MANUAL_ECOM && _ctx.deal.manualEcom3dsCode)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_62, [
                        _createElementVNode("div", _hoisted_63, _toDisplayString(_ctx.helper.trans('labels.manual_ecom_3ds_code')), 1),
                        _createElementVNode("div", _hoisted_64, _toDisplayString(_ctx.deal.manualEcom3dsCode), 1)
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.deal.paymentOption === _ctx.PaymentOption.MANUAL_ECOM)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_65, [
                        _createElementVNode("div", _hoisted_66, _toDisplayString(_ctx.helper.trans('labels.client_card')), 1),
                        _createElementVNode("div", _hoisted_67, [
                          _createElementVNode("button", {
                            type: "button",
                            class: "btn btn-outline-primary btn-sm text-capitalize-first",
                            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.showClientCard && _ctx.showClientCard(...args)))
                          }, _toDisplayString(_ctx.helper.trans('labels.show_client_card')), 1)
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.showManualSbpQrAttachRow)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_68, [
                        _createElementVNode("div", _hoisted_69, _toDisplayString(_ctx.helper.trans('labels.manual_sbp_qr_deal_image')), 1),
                        _createElementVNode("div", _hoisted_70, [
                          _createVNode(_component_ManualSbpQrLinkEditor, {
                            deal: _ctx.deal,
                            onApplied: _ctx.onManualSbpQrApplied
                          }, null, 8, ["deal", "onApplied"])
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.deal.isVideoRequestAvailable)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_71, [
                        _createElementVNode("div", _hoisted_72, _toDisplayString(_ctx.helper.trans('button.request_video')), 1),
                        _createElementVNode("div", _hoisted_73, [
                          _createElementVNode("button", {
                            type: "button",
                            class: "btn btn-outline-primary btn-sm text-capitalize-first",
                            disabled: _ctx.isVideoRequested(_ctx.deal),
                            title: _ctx.isVideoRequested(_ctx.deal) ? _ctx.dateHelper.format(_ctx.deal.videoRequestedUntil) : null,
                            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.requestVideo && _ctx.requestVideo(...args)))
                          }, _toDisplayString(_ctx.isVideoRequested(_ctx.deal) ? _ctx.helper.trans('button.video_requested') : _ctx.helper.trans('button.request_video')), 9, _hoisted_74)
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true)
          ]),
          (_ctx.deal && _ctx.deal.externalNspkTransaction)
            ? (_openBlock(), _createElementBlock("div", _hoisted_75, [
                _createElementVNode("div", _hoisted_76, [
                  _createElementVNode("span", _hoisted_77, _toDisplayString(_ctx.$t('labels.external_transaction')), 1)
                ]),
                _createElementVNode("div", _hoisted_78, [
                  _createElementVNode("div", _hoisted_79, [
                    _createElementVNode("div", _hoisted_80, [
                      _createElementVNode("div", _hoisted_81, _toDisplayString(_ctx.$t('labels.tx_id')), 1),
                      _createElementVNode("div", _hoisted_82, [
                        _createElementVNode("div", _hoisted_83, [
                          _createTextVNode(_toDisplayString(_ctx.deal.externalNspkTransaction.txId) + " ", 1),
                          _createVNode(_component_copy_button, {
                            value: _ctx.deal.externalNspkTransaction.txId
                          }, null, 8, ["value"])
                        ])
                      ])
                    ]),
                    (_ctx.deal.externalNspkTransaction.data.txNum)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_84, [
                          _createElementVNode("div", _hoisted_85, _toDisplayString(_ctx.$t('labels.tx_num')), 1),
                          _createElementVNode("div", _hoisted_86, [
                            _createElementVNode("div", _hoisted_87, [
                              _createTextVNode(_toDisplayString(_ctx.deal.externalNspkTransaction.data.txNum) + " ", 1),
                              _createVNode(_component_copy_button, {
                                value: _ctx.deal.externalNspkTransaction.data.txNum
                              }, null, 8, ["value"])
                            ])
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.deal.externalNspkTransaction.data.paymentSystemTransferNum)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_88, [
                          _createElementVNode("div", _hoisted_89, _toDisplayString(_ctx.$t('labels.paymentSystemTransferNum')), 1),
                          _createElementVNode("div", _hoisted_90, [
                            _createElementVNode("div", _hoisted_91, [
                              _createTextVNode(_toDisplayString(_ctx.deal.externalNspkTransaction.data.paymentSystemTransferNum) + " ", 1),
                              _createVNode(_component_copy_button, {
                                value: _ctx.deal.externalNspkTransaction.data.paymentSystemTransferNum
                              }, null, 8, ["value"])
                            ])
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.deal.externalNspkTransaction.data.sender)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_92, [
                          _createElementVNode("div", _hoisted_93, _toDisplayString(_ctx.$t('labels.sender')), 1),
                          _createElementVNode("div", _hoisted_94, [
                            _createElementVNode("div", _hoisted_95, [
                              _createVNode(_component_ExternalNspkSender, {
                                value: _ctx.deal.externalNspkTransaction.data.sender
                              }, null, 8, ["value"])
                            ])
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_96, [
                      _createElementVNode("div", _hoisted_97, _toDisplayString(_ctx.$t('labels.service')), 1),
                      _createElementVNode("div", _hoisted_98, [
                        _createElementVNode("div", _hoisted_99, _toDisplayString(_ctx.deal.externalNspkTransaction.service), 1)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_100, [
                      _createElementVNode("div", _hoisted_101, _toDisplayString(_ctx.$t('labels.status')), 1),
                      _createElementVNode("div", _hoisted_102, [
                        _createElementVNode("div", _hoisted_103, _toDisplayString(_ctx.deal.externalNspkTransaction.status), 1)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_104, [
                      _createElementVNode("div", _hoisted_105, _toDisplayString(_ctx.$t('labels.date')), 1),
                      _createElementVNode("div", _hoisted_106, [
                        _createElementVNode("div", _hoisted_107, _toDisplayString(_ctx.dateHelper.format(_ctx.deal.externalNspkTransaction.updatedAt)), 1)
                      ])
                    ])
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_108, [
            _createElementVNode("span", _hoisted_109, _toDisplayString(_ctx.$t('labels.history')), 1)
          ]),
          _createElementVNode("div", _hoisted_110, [
            _createElementVNode("div", _hoisted_111, [
              _createElementVNode("table", _hoisted_112, [
                _createElementVNode("thead", null, [
                  _createElementVNode("tr", null, [
                    _createElementVNode("th", _hoisted_113, _toDisplayString(_ctx.helper.trans('labels.date')), 1),
                    _createElementVNode("th", _hoisted_114, _toDisplayString(_ctx.helper.trans('labels.status')), 1),
                    _createElementVNode("th", _hoisted_115, _toDisplayString(_ctx.helper.trans('labels.initiator')), 1)
                  ])
                ]),
                _createElementVNode("tbody", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dealHistoriesResponse.items, (history) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      key: history.id
                    }, [
                      _createElementVNode("td", _hoisted_116, _toDisplayString(_ctx.dateHelper.format(history.date)), 1),
                      _createElementVNode("td", _hoisted_117, [
                        _createElementVNode("div", _hoisted_118, [
                          _createElementVNode("div", null, [
                            (history.action)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_119, _toDisplayString(_ctx.helper.trans(`deal_history_action.${history.action}`)), 1))
                              : (_openBlock(), _createElementBlock("span", _hoisted_120, _toDisplayString(_ctx.helper.trans(`deal_status.${history.status}`)), 1)),
                            (!history.action && history.disputeAttachment)
                              ? (_openBlock(), _createElementBlock("a", {
                                  key: 2,
                                  href: `${_ctx.api.baseUrl()}/attachments/${history.disputeAttachment}`,
                                  target: "_blank"
                                }, [
                                  _createVNode(_component_SvgIcon, {
                                    class: "icon icon__warning icon__small",
                                    icon: "paperclip"
                                  })
                                ], 8, _hoisted_121))
                              : _createCommentVNode("", true)
                          ]),
                          (history.action === 'AMOUNT_CHANGED' && history.previousAmount && history.newAmount)
                            ? (_openBlock(), _createElementBlock("small", _hoisted_122, _toDisplayString(history.previousAmount) + " -> " + _toDisplayString(history.newAmount) + " " + _toDisplayString(history.amountCurrency || ''), 1))
                            : _createCommentVNode("", true),
                          (history.action === 'DISPUTE_AUTOCLOSE_PAUSED' && history.suspendDisputeAutocloseAt)
                            ? (_openBlock(), _createElementBlock("small", _hoisted_123, _toDisplayString(_ctx.helper.trans('labels.pause_until', {date: _ctx.dateHelper.format(history.suspendDisputeAutocloseAt), comment: history.suspendDisputeComment || ''})), 1))
                            : _createCommentVNode("", true),
                          (!history.action && (history.disputeReason === _ctx.DisputeReason.INVALID_SUM || history.disputeReason === _ctx.DisputeReason.PART_PAYOUT))
                            ? (_openBlock(), _createElementBlock("span", _hoisted_124, [
                                _cache[5] || (_cache[5] = _createTextVNode(" (")),
                                _createElementVNode("span", _hoisted_125, _toDisplayString(_ctx.helper.trans(`dispute_reason.${history.disputeReason}`)), 1),
                                _createTextVNode(": " + _toDisplayString(_ctx.numberFormatter.formatNumber(history.disputeReasonData.amount, 2)) + " " + _toDisplayString(_ctx.deal.takerSum.currency) + ") ", 1)
                              ]))
                            : (!history.action && _ctx.isPayOutReceiptCheck(_ctx.deal.type, history.disputeReason))
                              ? (_openBlock(), _createBlock(_component_ReceiptCheckStatus, {
                                  key: 3,
                                  reason: history.disputeReason,
                                  data: history.disputeReasonData
                                }, null, 8, ["reason", "data"]))
                              : (!history.action && history.disputeReason)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_126, " (" + _toDisplayString(_ctx.helper.trans(`dispute_reason.${history.disputeReason}`)) + ") ", 1))
                                : _createCommentVNode("", true)
                        ])
                      ]),
                      _createElementVNode("td", _hoisted_127, [
                        (history.initiatorRole)
                          ? (_openBlock(), _createElementBlock("small", _hoisted_128, _toDisplayString(_ctx.helper.trans(`user_roles.${history.initiatorRole}`)), 1))
                          : (_openBlock(), _createElementBlock("small", _hoisted_129, _toDisplayString(_ctx.helper.trans(`initiator_type.${history.initiatorType}`)), 1))
                      ])
                    ]))
                  }), 128))
                ])
              ]),
              (_ctx.dealHistoriesResponse.totalCount > _ctx.dealHistoriesResponse.items.length)
                ? (_openBlock(), _createBlock(_component_b_pagination, {
                    key: 0,
                    modelValue: _ctx.historyPage,
                    "onUpdate:modelValue": [
                      _cache[2] || (_cache[2] = ($event: any) => ((_ctx.historyPage) = $event)),
                      _cache[3] || (_cache[3] = ($event: any) => (_ctx.loadHistory()))
                    ],
                    "total-rows": _ctx.dealHistoriesResponse.totalCount,
                    "per-page": _ctx.dealHistoriesResponse.limit,
                    limit: 20,
                    "prev-text": "Back",
                    "next-text": "Next",
                    align: "start",
                    "first-number": "",
                    "hide-goto-end-buttons": "",
                    "hide-ellipsis": ""
                  }, null, 8, ["modelValue", "total-rows", "per-page"]))
                : _createCommentVNode("", true)
            ])
          ])
        ]),
        _: 1
      }, 512),
      _createVNode(_component_Popup, {
        ref: (el) => _ctx.clientCardPopup = el,
        title: _ctx.helper.trans('labels.client_card'),
        onOnClose: _ctx.hideClientCard
      }, {
        default: _withCtx(() => [
          (_ctx.clientCardData)
            ? (_openBlock(), _createElementBlock("div", _hoisted_130, [
                _createElementVNode("div", _hoisted_131, [
                  _createElementVNode("label", _hoisted_132, _toDisplayString(_ctx.helper.trans('labels.card_number')), 1),
                  _createElementVNode("input", {
                    type: "text",
                    class: "form-control",
                    value: _ctx.formatCardRequisites(_ctx.clientCardData.cardNumber),
                    readonly: ""
                  }, null, 8, _hoisted_133)
                ]),
                _createElementVNode("div", _hoisted_134, [
                  _createElementVNode("label", _hoisted_135, _toDisplayString(_ctx.helper.trans('labels.expiry')), 1),
                  _createElementVNode("input", {
                    type: "text",
                    class: "form-control",
                    value: `${_ctx.clientCardData.expiryMonth}/${_ctx.clientCardData.expiryYear}`,
                    readonly: ""
                  }, null, 8, _hoisted_136)
                ]),
                _createElementVNode("div", _hoisted_137, [
                  _createElementVNode("label", _hoisted_138, _toDisplayString(_ctx.helper.trans('labels.cardholder')), 1),
                  _createElementVNode("input", {
                    type: "text",
                    class: "form-control",
                    value: _ctx.clientCardData.cardholderName,
                    readonly: ""
                  }, null, 8, _hoisted_139)
                ]),
                _createElementVNode("div", _hoisted_140, [
                  _createElementVNode("label", _hoisted_141, _toDisplayString(_ctx.helper.trans('labels.cvv')), 1),
                  _createElementVNode("input", {
                    type: "text",
                    class: "form-control",
                    value: _ctx.clientCardData.cvv,
                    readonly: ""
                  }, null, 8, _hoisted_142)
                ]),
                _createElementVNode("div", _hoisted_143, [
                  _createElementVNode("button", {
                    type: "button",
                    class: "btn btn-outline-dark btn-sm text-capitalize-first",
                    onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.hideClientCard && _ctx.hideClientCard(...args)))
                  }, _toDisplayString(_ctx.helper.trans('button.ok')), 1)
                ])
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["title", "onOnClose"]),
      _createVNode(_component_ConfirmPopup, { ref: "confirmPopup" }, null, 512)
    ]),
    _: 1
  }, 8, ["title", "onOnClose"]))
}